import { useBreakpointValue } from '@genial/utils';

import { BarSelectedItemsDesktop } from './Desktop';
import { BarSelectedItemsMobile } from './mobile';
import { BarSelectedItemsTablet } from './tablet';

interface BarSelectedItemsProps {
  countSelected: number;
  onBatchAction: (action: 'block' | 'unblock') => void;
  handleSelecteItems?: (value: string) => void;
  isSelectAll?: boolean;
}

export const BarSelectedItems = (props: BarSelectedItemsProps) => {
  const responsiveBarSelectedItems = useBreakpointValue({
    base: <BarSelectedItemsMobile {...props} />,
    sm: <BarSelectedItemsTablet {...props} />,
    lg: <BarSelectedItemsDesktop {...props} />,
  });

  return responsiveBarSelectedItems;
};
